module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 116);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(117);


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies
 */
var NotFoundScreen = __webpack_require__(118);

/**
 * Expose NotFoundScreen
 */
module.exports = NotFoundScreen;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Module dependencies
 */

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var EmptyState = __webpack_require__(4);
var Icon = __webpack_require__(119);

/**
 * NotFoundScreen
 */

var _ref2 = _jsx(Icon, {});

var NotFoundScreen = function NotFoundScreen(_ref) {
  var title = _ref.title,
      link = _ref.link,
      className = _ref.className;
  return (
    /* eslint-disable max-len */
    _jsx(EmptyState, {
      icon: _ref2,
      title: title,
      link: link,
      className: className
    })
  );
};

NotFoundScreen.propTypes = {
  title: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }),
  className: PropTypes.string
};

NotFoundScreen.defaultProps = {
  title: 'Parece que esta página no existe',
  className: '',
  link: null
};

/**
 * Expose NotFoundScreen
 */

module.exports = NotFoundScreen;

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Module dependencies
 */

var React = __webpack_require__(0);

/**
 * Icon
 */

var
/* eslint-disable max-len */
_ref = _jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "251",
  height: "154",
  viewBox: "0 0 251 154"
}, void 0, _jsx("g", {
  fill: "none",
  fillRule: "evenodd"
}, void 0, _jsx("path", {
  fill: "#CCC",
  d: "M18 151h233v2H18v-2zm-18 0h13v2H0v-2z"
}), _jsx("path", {
  fill: "#DFDFDF",
  d: "M152 133v8.165h-50V133H28v8.165c0 5.52 3.405 11.827 13.647 11.835l168.906-.291C228.179 152.723 226.377 133 226 133h-74z"
}), _jsx("path", {
  fill: "#F7D032",
  d: "M153.303 133.42l-24.278.011 24.278.018z"
}), _jsx("path", {
  fill: "#FFF",
  d: "M58.513 132.71h139.604V34.572l-139.604.397z"
}), _jsx("path", {
  fill: "#BBB",
  d: "M30 147c.735 2.575 5.553 6.276 13.283 6.276L211 153c6.737 0 12.34-3.372 13-6H30z"
}), _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M198 132H59"
}), _jsx("path", {
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M225 134v7.285c0 4.325-4.247 10.715-13.393 10.715H46.489"
}), _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M45 97V28a6 6 0 0 1 6-6h155a6 6 0 0 1 6 6v99"
}), _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M198 132.492V37.367c0-1.599-1.397-2.367-3-2.367l-112.35-.11-13.717.094-8.016.016c-1.041 0-1.6.524-1.603 1.567"
}), _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeWidth: "2",
  d: "M113.857 50.642c-7.217 3.53-13.356 9.515-17.051 17.44m-3.464 15.03c-.125 8.971 3.073 17.673 8.959 24.283a34.437 34.437 0 0 0 11.2 8.329c9.825 4.58 20.731 4.139 29.925-.271 7.325-3.513 13.564-9.546 17.302-17.563 2.58-5.533 3.67-11.371 3.436-17.045-.282-6.799-2.468-13.362-6.275-18.882a34.465 34.465 0 0 0-13.857-11.713 34.436 34.436 0 0 0-13.932-3.236c-5.63-.107-11.2 1.16-16.243 3.628"
}), _jsx("g", {}, void 0, _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "square",
  strokeWidth: "2",
  d: "M162.369 44.033l-9.286 10.683"
}), _jsx("path", {
  fill: "#E6E6E6",
  d: "M177.11 39.194l-4.262 4.902c-2.12 2.44-6.34 2.241-9.423-.438-3.083-2.68-3.866-6.831-1.746-9.27l14.488-16.667 13.418-15.436c2.118-2.436 6.339-2.239 9.422.44 3.082 2.68 3.865 6.833 1.747 9.269"
}), _jsx("path", {
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeWidth: "2",
  d: "M161.755 35.04c-2.12 2.438-1.657 6.312 1.032 8.649 2.689 2.337 6.589 2.257 8.71-.182l14.487-16.666 13.418-15.436"
})), _jsx("path", {
  fill: "#CCC",
  d: "M126.321 96.605h4.914v5.136h-4.914v-5.136zm-5.309-28.358c2.009-2.165 4.766-3.247 8.272-3.247 3.243 0 5.84.926 7.79 2.778 1.95 1.852 2.926 4.218 2.926 7.099 0 1.744-.358 3.16-1.074 4.246-.716 1.087-2.16 2.684-4.333 4.79-1.58 1.531-2.605 2.828-3.074 3.89-.47 1.061-.704 2.63-.704 4.703h-4.395c0-2.354.28-4.25.84-5.691.559-1.44 1.785-3.09 3.678-4.95l1.976-1.951a8.174 8.174 0 0 0 1.432-1.754c.658-1.07.987-2.18.987-3.333 0-1.613-.481-3.012-1.444-4.197-.963-1.186-2.556-1.778-4.778-1.778-2.749 0-4.65 1.02-5.704 3.062-.592 1.135-.93 2.773-1.012 4.913H118c0-3.555 1.004-6.415 3.012-8.58z"
})));

var Icon = function Icon() {
  return _ref;
};

/**
 * Expose Icon
 */

module.exports = Icon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies
 */
var EmptyState = __webpack_require__(5);

/**
 * Expose EmptyState
 */
module.exports = EmptyState;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Module dependencies
 */

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var classNames = __webpack_require__(2);

/**
 * EmptyState
 */

var EmptyState = function EmptyState(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      link = _ref.link,
      className = _ref.className;

  var classes = classNames('ui-empty-state', className);

  return _jsx('div', {
    className: classes
  }, void 0, _jsx('div', {
    className: 'ui-empty-state__container'
  }, void 0, icon && _jsx('span', {
    className: 'ui-empty-state__icon'
  }, void 0, icon), _jsx('h4', {
    className: 'ui-empty-state__title'
  }, void 0, title), description && _jsx('p', {
    className: 'ui-empty-state__description'
  }, void 0, description), _jsx('div', {
    className: 'ui-empty-state__link-container'
  }, void 0, link && React.createElement(
    'a',
    _extends({ href: link.href, className: 'ui-empty-state__link' }, { onClick: link.onClick || null }),
    link.text
  ))));
};

EmptyState.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }),
  className: PropTypes.string
};

EmptyState.defaultProps = {
  icon: null,
  description: null,
  className: '',
  link: null
};

/**
 * Expose EmptyState
 */

module.exports = EmptyState;

/***/ })

/******/ });